module.exports = __webpack_public_path__ + "static/media/wirecutter-empty.b48e145d.png";